<template>
    <order-scroll url="market-order/order-list" :params="{ type, keyword }" ref="orderscroll">
        <panel slot-scope="scope">
            <template v-for="row of scope.data">
                <goodsorderlist :row="row" :gotoWorkOrder="gotoWorkOrder">
                    <orderitems />
                </goodsorderlist>
            </template>
        </panel>
    </order-scroll>
</template>

<script>
import goodsorderlist from "./children/GoodsOrderList";
import orderitems from "./children/OrderItems";
export default {
    components: {
        goodsorderlist,
        orderitems
    },
    props: {
        gotoWorkOrder: {
            type: Function,
            default: null
        }
    },
    computed: {
        keyword() {
            return this.$store.state.shopkey
        },
        type() {
            if (this.active == 0) {
                return 'all'
            } else if (this.active == 1) {
                return 'un_pay'
            } else if (this.active == 2) {
                return 'un_delivery'
            } else if (this.active == 3) {
                return 'un_receive'
            }
        }
    },
    data() {
        return {
            active: Number(this.$route.params.active),
        }
    },
    methods: {
        refresh() {
            this.$refs.orderscroll.refresh()
        }
    },
}
</script>

<style lang="less" soped>

</style>